var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgAlertBellIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.333 11.334H14.6663V12.6673H1.33301V11.334H2.66634V6.66732C2.66634 3.7218 5.05415 1.33398 7.99967 1.33398C10.9452 1.33398 13.333 3.7218 13.333 6.66732V11.334ZM11.9997 11.334V6.66732C11.9997 4.45818 10.2088 2.66732 7.99967 2.66732C5.79053 2.66732 3.99967 4.45818 3.99967 6.66732V11.334H11.9997ZM5.99967 14.0007H9.99967V15.334H5.99967V14.0007Z",
    fill: "#4C5552"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAlertBellIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/AlertBellIcon.371d2974.svg";
export { ForwardRef as ReactComponent };